import firebase, { firebaseLooper } from "../services/firebase";

class ChannelService {
    channelsRef = firebase.database().ref("channels");

    async createChannel(data) {
        const { key } = this.channelsRef.push();

        await this.channelsRef.child(key).update({ id: key, ...data });

        return await this.channelsRef
            .child(key)
            .once("value")
            .then(snap => snap.val());
    }

    async getChannels() {
        return await this.channelsRef.once("value").then(snap => firebaseLooper(snap.toJSON()));
    }

    async deleteChannel(channelId) {
        await this.channelsRef.child(channelId).remove();

        return { id: channelId };

        // await firebase.database().ref(`${this.channelsRef.key}/${channelId}`).remove();
    }

    setOnAddChannelListener(actionCallback) {
        this.channelsRef.on("child_added", actionCallback);

        // .on("child_added", snap => actionCallback(snap.val()));
    }
}

const channelService = new ChannelService();

export default channelService;
